

$document.addEventListener('DOMContentLoaded', function() {
  // Your code here using document.querySelector() instead of $()

  // START:- FAQ section
  $(document).on("click", ".js-accordion--heading", function () {
    var $this = $(this),
      $_closest = $this.closest(".accordion-wrapp"),
      $find = $_closest.find(".accordion--content");
    $find.slideToggle();
    $this.toggleClass("active");
  });
  // END:- FAQ section

  // START:- testimonial section slider
  $(".slick-testimonial-slider").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  // END:- Testimonial section slider

  // START:- read more
  $(".testimonial--wrapper .content").hide();
  $(".show_hide").on("click", function () {
    var $content = $(this).siblings('.content'); // Find the content sibling
    var txt = $content.is(':visible') ? 'Read More' : 'Read Less';
    $(this).text(txt);
    $content.slideToggle(200);
  });
  // END
});
